import { useState, useEffect } from "react";
export type BreakPoints = "mobile" | "laptop" | "desktop";

interface Size {
  min: number;
  max: number;
}

interface DeviceSize extends Record<string, Size> {}

const devicesSize: DeviceSize = {
  mobile: {
    min: 0,
    max: 500,
  },
  laptop: {
    min: 501,
    max: 1280,
  },
  desktop: {
    min: 1281,
    max: Infinity,
  },
};

const useMediaQuery = (): BreakPoints => {
  const [device, setDevice] = useState<BreakPoints>("desktop");
  const { mobile, laptop, desktop } = devicesSize;

  useEffect(() => {
    const handleResize = (): void => {
      if (window.innerWidth >= mobile.min && window.innerWidth <= mobile.max) {
        setDevice("mobile");
      } else if (
        window.innerWidth >= laptop.min &&
        window.innerWidth <= laptop.max
      )
        setDevice("laptop");
      else if (
        window.innerWidth >= desktop.min &&
        window.innerWidth <= desktop.max
      )
        setDevice("desktop");
    };
    window.addEventListener("resize", handleResize);

    handleResize();
    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, [desktop, laptop, mobile]);
  return device;
};

export default useMediaQuery;
